// import Home from './pages/Home';
// import Login from './pages/Login';
// import Register from './pages/Register';

// import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
// import { useContext } from 'react';
// import { AuthContext } from './context/AuthContext';
// function App() {
// 	const currentUser = useContext(AuthContext);

// 	const ProtectedRoute = ({ childrens }) => {
// 		if (!currentUser) {
// 			return <Navigate to="/login" />;
// 		}
// 	};

// 	return (
// 		<>
// 			<BrowserRouter>
// 				<Routes>
// 					<Route pathg="/">
// 						<Route
// 							index
// 							element={
// 								<ProtectedRoute>
// 									<Home />
// 								</ProtectedRoute>
// 							}
// 						/>
// 						<Route path="login" element={<Login />} />
// 						<Route path="register" element={<Register />} />
// 					</Route>
// 				</Routes>
// 			</BrowserRouter>
// 		</>
// 	);
// }

// export default App;

import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import './pages/style.scss';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useContext } from 'react';
import { AuthContext } from './context/AuthContext';

function App() {
	const { currentUser } = useContext(AuthContext);

	const ProtectedRoute = ({ children }) => {
		if (!currentUser) {
			return <Navigate to="/login" />;
		} else {
			return children;
		}
		// return children;
	};

	return (
		<BrowserRouter>
			<Routes>
				<Route path="/">
					<Route
						index
						element={
							<ProtectedRoute>
								<Home />
							</ProtectedRoute>
						}
					/>
					<Route path="login" element={<Login />} />
					<Route path="register" element={<Register />} />
				</Route>
			</Routes>
		</BrowserRouter>
	);
}

export default App;
